import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "../core";
import { pathShape, resolveScreen } from "../screens";

/**
 * Emite screen_viewed en cada cambio de ruta.
 *
 * NO lee el querystring. Aunque el perfil de paciente sincroniza su solapa a
 * `?tab=N`, ese N es un índice posicional sobre un array DINÁMICO
 * (`visibleTabKeys` en NewPortal/TabsComponent.tsx oculta solapas según la red,
 * p. ej. Encuestas), así que traducir el índice a un nombre desde acá daría
 * nombres equivocados en cuanto cambie la visibilidad. Esa solapa se instrumenta
 * dentro del propio componente con useTrackedSubview y su clave real.
 *
 * Tampoco se serializa location.search: /reset-password lleva ?token= y
 * `sensor` / `start_date` / `end_date` son ruido o información clínica.
 */
export function usePageTracking(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    analytics.page(resolveScreen(pathname), { path_shape: pathShape(pathname) });
  }, [pathname]);
}
